/**
 * ProjectUsageView — `/projects/$projectId/usage` (Doc 25 §F3).
 *
 * Tab "Consumo IA" del shell del proyecto. Mismo dashboard que la
 * vista tenant pero scoped al projectId del path. NO muestra balance
 * — eso es responsabilidad del tenant admin via /settings/usage.
 */

import { useTranslation } from 'react-i18next'

import { ScrollPage } from '../../components/shell/ScrollPage'
import { UsageDashboard } from '../../components/usage/UsageDashboard'
import { useProjectContext } from './ProjectShell'

export function ProjectUsageView() {
  const { t } = useTranslation(['usage'])
  const { project } = useProjectContext()

  return (
    <ScrollPage>
      <div className="max-w-7xl">
        <header className="mb-6">
          <h1 className="font-display text-2xl font-semibold text-ink">
            {t('usage:project_title')}
          </h1>
          <p className="mt-1 font-body text-sm text-ink-muted max-w-prose">
            {t('usage:page_subtitle')}
          </p>
        </header>

        <UsageDashboard projectId={project.id} showBalance={false} />
      </div>
    </ScrollPage>
  )
}
